import {email, minLength, required} from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core/dist/index.esm";
import {mixins} from "../app/mixin";
import intlTelInput from 'intl-tel-input';

mixins.push({
    el: '.contactUs',
    delimiters: ['${', '}'],
    validations: {
        fullName: {required},
        phone: {required, minLength: minLength(10)},
        email: {required, email},
        message: {required, minLength: minLength(1)},
    },
    data() {
        return {
            api: window.api,
            v: useVuelidate(),
            fullName: '',
            companyName: '',
            phone: '',
            email: '',
            message: '',
            selectedMap: '',
            isVisible: false,
            errorMessages: window.errorMessages,
            lang: window.lang,
            maps: ['', '', '', ''],
            siteKey: window.siteKey,
            isSubmitting: false,
            iti: null
        };
    },
    mounted() {
        console.log('test 2: vualidate')
        const input = document.getElementById("phone");
        const inputMobile = document.getElementById("phone-mobile");
        this.iti = intlTelInput(input, {
            separateDialCode: true,
            initialCountry: "tr",
            preferredCountries: [],
            useFullscreenPopup: false,
            hiddenInput: "full",
            utilsScript: "//cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.3/js/utils.js"
        });
        this.iti = intlTelInput(inputMobile, {
            separateDialCode: true,
            initialCountry: "tr",
            preferredCountries: [],
            useFullscreenPopup: false,
            hiddenInput: "full",
            utilsScript: "//cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.3/js/utils.js"
        });
        input.addEventListener("input", function () {
            // Remove non-numeric characters
            input.value = input.value.replace(/\D/g, '');
        });
        inputMobile.addEventListener("input", function () {
            // Remove non-numeric characters
            inputMobile.value = inputMobile.value.replace(/\D/g, '');
        });
    },
    methods: {
        toggleMap(index, mapLocation, href) {
            this.maps[index] = href;
            
            if (mapLocation !== this.selectedMap) {
                this.selectedMap = mapLocation
            } else {
                this.selectedMap = ''
            }
        },
        resetForm() {
            this.fullName = '';
            this.companyName = '';
            this.phone = '';
            this.email = '';
            this.message = '';
            this.v.$reset();
        },
        async submitForm() {
            this.v.$touch()
            
            if (this.v.$invalid) {
                return;
            }
            
            // Get the phone number from intlTelInput object
            // And set it to this.phone variable
            this.phone = this.iti.getNumber();
            
            this.isSubmitting = true;
            
            try {
                const recaptchaToken = await grecaptcha.execute(this.siteKey, {action: 'submit'});
                const response = await fetch(`${this.api}/contacts`, {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.lang
                    },
                    body: JSON.stringify({
                        fullName: this.fullName,
                        companyName: this.companyName,
                        tel: this.phone,
                        email: this.email,
                        message: this.message,
                        recaptchaToken: recaptchaToken
                    })
                })
                
                if (response.ok) {
                    this.isVisible = true;
                    this.resetForm();
                    
                    setTimeout(() => {
                        this.isVisible = false;
                    }, 15000);
                } else {
                    console.error('Form submission failed:', response.status);
                }
            } catch (e) {
                console.log('Form submission error', e)
            } finally {
                this.isSubmitting = false;
            }
        }
    },
    computed: {
        errorMessage() {
            let fullName, phone, email, message
            if (this.v.fullName.$error) {
                fullName = this.errorMessages.required
            }
            if (this.v.phone.$error) {
                if (this.phone.length === 0) {
                    phone = this.errorMessages.required
                }
                else if (this.v.phone.minLength) {
                    phone = this.errorMessages.phoneAtLeastElevenCharacter
                }
            }
            if (this.v.email.$error) {
                if (this.email.length === 0) {
                    email = this.errorMessages.required
                }
                else if (this.v.email.$error) {
                    email = this.errorMessages.emailIsInvalid
                }
            }
            if (this.v.message.$error) {
                message = this.errorMessages.required
            }
            return {
                fullName,
                phone,
                email,
                message,
            }
        },
        isButtonDisabled() {
            return this.v.$invalid
        },
    }
});
